function LiveGameStatDivider() {
    return (
        <div className='w-full border-t border-zinc-700 my-0.5' />
    );
}

export default LiveGameStatDivider;
